import header from '~/store/header'

const modules = {
  header,
}

export default {
  namespaced: true,
  modules,
}
